import React from 'react';

import { fireGAEvent } from '@/analytics';
import i18n from '@i18n';
import ResponsibleGamingArrow from 'nike-ui/src/icons/svg/responsible-gaming-arrow-sv.svg';
import PopupNg from '@/ui/PopupNg';
import { closeCookiebotDialog } from 'nike-ui/src/components/cookie';

export const ResponsibleGaming = React.memo(() => {
    const onClick = () => {
        PopupNg.dispatcher.closeAll();
        PopupNg.dispatcher.open('information-duty', null, 1000);
        fireGAEvent('Paticka', 'Zodpovedne hranie');
        if (window.Cookiebot?.isOpen) {
            closeCookiebotDialog();
            window.Cookiebot.shouldReopen = true;
        }
    };

    return (
        <div className="responsible-gaming" data-atid="responsible-gaming" onClick={onClick}>
            {i18n('reality.check.gambling')}
            <ResponsibleGamingArrow />
        </div>
    );
});
